(function() {
  'use strict';
  angular.module('benefits')
  .component('disclaimer', {
    templateUrl: '/js/benefits/disclaimer.html' + appVersion
  });
})();
